<template>
  <v-card class="py-3 px-4">
    <v-card-title primary-title class="pb-2 pt-0">
      <h3>Listing Company:&nbsp;</h3>
      <span>{{bid.listing.listingCompany.name}}</span>
    </v-card-title>

    <v-container>
      <v-layout row
                v-if="hasOfficePermission(bid.listing) &&
                    bid.status !== bidStatus.ACCEPTED">
        <v-flex md2>
          <v-select
            label="Loads"
            :items="_.range(1, bid.numberOfLoadsSelections + 1)"
            v-model="bid.numberOfLoads"
            :disabled="bid.status !== bidStatus.ACTIVE"></v-select>
        </v-flex>
        <v-flex md9 class="ml-2">
          <v-btn color="accent" @click="acceptBid(bid)"
                 :disabled="bid.status === bidStatus.CANCELLED_BY_BIDDER">
            <v-icon dark class="pr-2">check_circle</v-icon>
            Accept
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <bid-form @refresh="$emit('refresh')"
              :hide-form="false"
              :disable-form="false"
              :bid="bid">
    </bid-form>
  </v-card>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import { mapGetters } from 'vuex';
import BidForm from '@/components/BidForm';
import {
  accountHasOfficePermission,
} from '@/store/permissions';

export default {
  name: 'BidDetails',
  props: {
    bid: {
      type: Object,
    },
  },
  components: {
    BidForm,
  },
  methods: {
    ...mapGetters('profiles', [
      'findCompanyAccount',
    ]),
    hasOfficePermission(listing) {
      const companyId = _.get(listing, 'listingCompany.id', null);
      return accountHasOfficePermission(this.findCompanyAccount()(companyId));
    },
    async acceptBid(bid) {
      try {
        window.__insp.push(['tagSession', 'accept_bid']);
        await API.bid.acceptBid({ bidId: bid.id, numberOfLoads: bid.numberOfLoads });
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Bid Accepted',
        });
        this.$emit('refresh');
      } catch (error) {
        window.__insp.push(['tagSession', 'accept_bid_error']);
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      }
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BidDetails.vue